import styled from "styled-components";

const InputField = styled.input`
  font-size: 14px;
  width: 100%;
  height: 50px;
  border: 1px solid transparent;
  background: var(--color-gray-50);
  padding-left: 18px;
  font-family: var(--font-secondary);
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.01em;
  text-align: left;
  color: black;
  margin: auto;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  transition: box-shadow 150ms ease;

  &:focus,
  &:focus-visible {
    outline: none;
    border-color: transparent;
    box-shadow: 0 0 0 2px rgba(6, 182, 212, 0.45);
  }

  &::placeholder {
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.2px;
    text-align: left;
  }

  &:disabled {
    background: var(--color-gray-100);
    pointer-events: none;
    user-select: none;
    color: var(--color-gray-300);
  }
`;

export default InputField;
